exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collection[data-v-2f7e9d8e]{z-index:999;position:absolute;top:450px;right:12px}", ""]);

// exports
